module.exports = ["#ffffff","#cccccc","#808080","#343434","#000000","#C8E6C9","#81C784","#4CAF50","#388E3C","#1B5E20","#B2EBF2","#4DD0E1","#00BCD4","#0097A7","#006064","#BBDEFB","#64B5F6","#2196F3","#1976D2","#0D47A1","#D1C4E9","#9575CD","#673AB7","#512DA8","#311B92","#F8BBD0","#F06292","#E91E63","#C2185B","#880E4F","#FFCDD2","#E57373","#F44336","#D32F2F","#B71C1C","#FFE0B2","#FFB74D","#FF9800","#F57C00","#E65100","#FFF9C4","#FFF176","#FFEB3B","#FBC02D","#F57F17"]


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/droplets/_bubble-options/components/inline-text/font-colors.json
// module id = Feis
// module chunks = 0